import { render, staticRenderFns } from "./fileDown.vue?vue&type=template&id=749cf53e&scoped=true"
import script from "./fileDown.vue?vue&type=script&lang=js"
export * from "./fileDown.vue?vue&type=script&lang=js"
import style0 from "./fileDown.vue?vue&type=style&index=0&id=749cf53e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749cf53e",
  null
  
)

export default component.exports